import gql from 'graphql-tag';

export const GET_MEMBER_APPLICANT_INFO = gql`
  query GetMemberApplicantInfo($memberId: Int!, $programId: Int) {
    memberApplicantInfo(memberId: $memberId, programId: $programId) {
      id
      programId
      memberId
      termsAccepted
      clientId
      memberFullName
      memberEmail
      createdDate
      updatedDate
      
      briefTemplate {
        introMessage
        clientId
        programId
        backendServerPostProjectId
        
        agreementIteration {
          price
          briefUrl
          paymentTerms
          requireContentRights
          contentUsageRights
          commissionDescription
          productDescription
          requireInstagramInsights
          offersPayment
          offersProduct
          offersCommission
          disableCreatorEdits
          requireIgPartnershipAdsAccess
          requireIgBcPromoteAccess
          metaBamAccessStartDate
          metaBamAccessEndDate
          requireMetaBamAccess
          igBcPromoteAccessStartDate
          igBcPromoteAccessEndDate
          requireTiktokSparkAdsAccess
          tiktokSparkAdsDuration
          
          contentGuidelines {
            id
            label
            requiresContentReview
            requiresBrandedContentTag
            postType
            networkType
            count
            acceptedPostTypes
            
            guidelines {
              title
              allowTitleEdition
              type
              instructions
              placeholder
            }
            
            dueDates {
              submission {
                type
                startDate
                endDate
                dueDateInDays
              }
              completion {
                type
                startDate
                endDate
                dueDateInDays
              }
            }
            
            attachments {
              filename
              url
              type
            }
          }
        }
        
        emailDetails {
          subject
          body
          resourceId
          additionalCc
          
          attachments {
            filename
            url
            type
          }
        }
        
        advertiserAccess {
          requireAccess
          startDate
          endDate
        }
        
        brandedContentAccess {
          requireAccess
        }
      }
      
      catalogOrderRequest {
        locationIds
        enableOOSCheck
        brandCatalogId
        selectionRuleId
        
        member {
          name
          email
        }
        
        creatorOrderRequest {
          email
          note
          
          line_items {
            quantity
            variant_id
            variant_title
            title
            price
          }
          
          shipping_address {
            address1
            address2
            city
            country
            first_name
            last_name
            phone
            province
            zip
            email
          }
        }
      }
    }
  }
`;
